export { default as handleDimension } from "./models/values/handleDimension.js"
export { default as handleFloat } from "./models/values/handleFloat.js"
export { default as handleOpacity } from "./models/values/handleOpacity.js"
export { default as handleRotate } from "./models/values/handleRotate.js"
export { default as handleBool } from "./models/values/handleBool.js"
export { default as handleInt } from "./models/values/handleInt.js"
export { default as handleStrokeWeight } from "./models/values/handleStrokeWeight.js"

export { default as Base } from "./models/Base.js"

export { default as Color } from "./models/Color.js"
export { default as Ellipse } from "./models/Ellipse.js"
export { default as Frame } from "./models/Frame.js"
export { default as Grid } from "./models/Grid.js"
export { default as Copy } from "./models/Copy.js"

export { default as PixelObject } from "./models/PixelObject.js"
export { default as Polygon } from "./models/Polygon.js"
export { default as Rectangle } from "./models/Rectangle.js"
export { default as Line } from "./models/Line.js"

export { default as Shape } from "./models/Shape"
export { default as Text } from "./models/Text"
export { default as Image } from "./models/Image"

export { default as Quad } from "./models/Quad.js"

export { default as Mouse } from "./models/Mouse.js"

export { default as Lissajous } from "./models/modifiers/lissajous.js"
export { default as Rose } from "./models/modifiers/rose.js"

import Root from "./models/Root.js"

export let Pixel = null

export function createPixel() {
    Pixel = new Root();
}

export function generateId() {
    return Math.round(Math.random() * 10000000)
}